import { memo, useCallback, useEffect, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// Servisni sloj
import { getVehicleServiceStatusesAPI } from "services/api/fleet/vehicles/services/api";
import { initialFleetVehicleServiceSearchForm } from "services/api/fleet/vehicles/services/consts";
import { VehicleServiceStatus } from "services/api/fleet/vehicles/services/types";

// UI
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { TextField } from "ui/components/TextField/TextField";

import { DEFAULT_SERVICE_STATUS_HEX, SERVICE_OPEN_OPTIONS, SERVICE_STATUS_HEX } from "../../consts";
import { ServiceSearchFiltersProps } from "./types";

const ServiceSearchFilters: React.FC<ServiceSearchFiltersProps> = (props) => {
  const { formValues, onSearchChange } = props;

  const { t } = useTranslate();

  const [statuses, setStatuses] = useState<VehicleServiceStatus[]>([]);

  useEffect(() => {
    fetchStatuses();
  }, []);

  const fetchStatuses = async () => {
    try {
      setStatuses(await getVehicleServiceStatusesAPI());
    } catch {
      setStatuses([]);
    }
  };

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onSearchChange({ ...formValues, search: e.target.value });
    },
    [formValues, onSearchChange]
  );

  const handleStatusChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      onSearchChange({ ...formValues, vehicleServiceStatusId: item.value || null });
    },
    [formValues, onSearchChange]
  );

  // Dropdown radi sa stringovima, a filter je trostanjski (svi / otvoreni / zatvoreni).
  const handleOpenChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      onSearchChange({
        ...formValues,
        isOpen: item.value ? item.value === "true" : null,
      });
    },
    [formValues, onSearchChange]
  );

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialFleetVehicleServiceSearchForm);
  }, [onSearchChange]);

  const statusItems: DropdownOption[] = statuses.map((status) => ({
    value: status.id,
    text: status.name,
    color: SERVICE_STATUS_HEX[status.color ?? ""] ?? DEFAULT_SERVICE_STATUS_HEX,
  }));

  return (
    <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-[240px]">
          <TextField
            type="text"
            name="search"
            value={formValues.search}
            onChange={handleSearchChange}
            placeholder="Naziv naloga ili servis..."
            startIcon="/media/icons/search.svg"
            cssClassName="bg-white"
          />
        </div>
        <div className="min-w-[200px]">
          <Dropdown
            name="vehicleServiceStatusId"
            placeholder="Status"
            options={statusItems}
            value={formValues.vehicleServiceStatusId}
            onChange={handleStatusChange}
            cssClassName="bg-white"
            width="full"
          />
        </div>
        <div className="min-w-[200px]">
          <Dropdown
            name="isOpen"
            placeholder="Svi nalozi"
            options={SERVICE_OPEN_OPTIONS}
            value={formValues.isOpen === null ? null : String(formValues.isOpen)}
            onChange={handleOpenChange}
            cssClassName="bg-white"
            width="full"
          />
        </div>
      <div className="flex items-center pb-2">
        <span
          onClick={handleResetFormClick}
          className="text-xs font-bold cursor-pointer text-gray-700"
        >
          {t("admin.reset")}
        </span>
      </div>
    </div>
  );
};

export default memo(ServiceSearchFilters);
